export default {
  'data2': [
    {
      'checks': '',
      'content': '',
      'description': '',
      'formType': '9',
      'isRead': '0',
      'isRequired': '1',
      'name': '个人身份信息-分隔栏',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '个人身份信息',
      'value': 'idInfo'
    },
    {
      'checks': '',
      'content': '',
      'description': '',
      'formType': '6',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '登记照',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '1寸白底登记照',
      'value': 'photo'
    },
    {
      'checks': '',
      'content': '',
      'description': '',
      'formType': '6',
      'isRead': '1',
      'isRequired': '0',
      'name': '登记照示例',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '登记照示例',
      'value': 'photoExample'
    },
    {
      'checks': '',
      'content': '请上传您的学历证书',
      'description': '大专及以上学历请上传学信网学历认证，大专以下学历请上传毕业证书',
      'formType': '5',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '学历证书',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '学信网或毕业证书',
      'value': 'diploma'
    },
    {
      'checks': '',
      'content': '请选择',
      'description': '',
      'formType': '7',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '学历',
      'optionsVlaue': 'EDUCATION',
      'orderIndex': '',
      'title': '学历',
      'value': 'education'
    },
    {
      'checks': '',
      'content': '请选择',
      'description': '',
      'formType': '7',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '是否从事过保险行业',
      'optionsVlaue': 'YES_NO',
      'orderIndex': '',
      'title': '是否从事过保险行业',
      titleWidth: '12em',
      'value': 'policyExp',
    },
    {
      'checks': '',
      'content': '请输入当前职业',
      'description': '',
      'formType': '7',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '当前职业',
      'optionsVlaue': 'CURRENT_JOB',
      'orderIndex': '',
      'title': '当前职业',
      'value': 'curWork'
    },
    {
      'checks': '',
      'content': '请选择',
      'description': '',
      'formType': '7',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '常住地区',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '常住地区',
      'value': 'province,city'
    },
    {
      'checks': '.{7,}(室|号)',
      'content': '请输入详细地址，需要精确到街道、小区、楼栋号及门牌号',
      'description': '请输入详细地址，需要精确到街道、小区、楼栋号及门牌号',
      'formType': '2',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'length': '256',
      'name': '详细地址',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '详细地址',
      'value': 'permanentWork'
    },
    {
      'checks': '',
      'content': '',
      'description': '',
      'formType': '9',
      'isRead': '0',
      'isRequired': '1',
      'name': '账户信息-分隔栏',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '结算账户信息',
      'value': 'bankInfo'
    },
    {
      'checks': '',
      'content': '您的收入将发放至此账户，请正确填写',
      'description': '',
      'formType': '1',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '银行卡号',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '银行卡号',
      'value': 'cardNo'
    },
    {
      'checks': '',
      'content': '根据银行卡号自动显示',
      'description': '',
      'formType': '7',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '开户行',
      'optionsVlaue': 'BANK_TYPE',
      'orderIndex': '',
      'title': '银行卡开户行',
      'value': 'bank'
    },
    {
      'checks': '',
      'content': '请选择您的开户行地区',
      'description': '',
      'formType': '7',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '开户行地区',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '开户行地区',
      'value': 'bankProvince,bankCity'
    },
    {
      'checks': '',
      'content': '请正确填写支行名称',
      'description': '',
      'formType': '1',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '支行名称',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '支行名称',
      'value': 'accountOpenBranch'
    },
    {
      'checks': '',
      'content': '',
      'description': '',
      'formType': '9',
      'isRead': '0',
      'isRequired': '1',
      'name': '入职信息-分隔栏',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '入职签约信息',
      'value': 'entryInfo'
    },
    {
      'checks': '',
      'content': '请您选择入职机构',
      'description': '',
      'formType': '10',
      'isRead': '1',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '入职机构',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '入职机构',
      'value': 'organizationId'
    },
    {
      'checks': '',
      'content': '请填写您的推荐人姓名',
      'description': '',
      'formType': '1',
      'isRead': '1',
      'isRequired': '0',
      'name': '推荐人姓名',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '推荐人姓名',
      'value': 'recommenderName'
    },
    {
      'checks': '',
      'content': '请填写您的推荐人工号',
      'description': '',
      'formType': '1',
      'isRead': '1',
      'isRequired': '0',
      'name': '推荐人工号',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '推荐人工号',
      'value': 'recommenderCode'
    }
  ],
  'data1': [
    {
      'checks': '',
      'content': '',
      'description': '',
      'formType': '9',
      'isRead': '0',
      'isRequired': '1',
      'name': '个人身份信息-分隔栏',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '个人身份信息',
      'value': 'idInfo'
    },
    {
      'checks': '',
      'content': '',
      'description': '请上传照片并确保清晰、完整',
      titleCover: {
        title: '身份证照片',
        description: '请上传照片并确保清晰、完整'
      },
      'formType': '6',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '身份证头像',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '身份证照片',
      'value': 'cardFront'
    },
    {
      'checks': '',
      'content': '',
      'description': '',
      'formType': '6',
      'isRead': '0',
      'isRequired': '1',
      'name': '身份证国徽',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '身份证国徽面',
      'value': 'cardBack'
    },
    {
      'checks': '',
      'content': '上传身份证正反面后自动显示',
      'description': '',
      'formType': '1',
      'isRead': '1',
      'isRequired': '1',
      'length': '30',
      'name': '姓名',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '姓名',
      'value': 'name'
    },
    {
      'checks': '',
      'content': '上传身份证正反面后自动显示',
      'description': '',
      'formType': '1',
      'isRead': '1',
      'isRequired': '1',
      'name': '性别',
      'optionsVlaue': 'SEX',
      'orderIndex': '',
      'title': '性别',
      'value': 'sex'
    },
    {
      'checks': '(^\\d{15}$)|(^\\d{18}$)|(^\\d{17}(\\d|X|x)$)',
      'content': '上传身份证正反面后自动显示',
      'description': '',
      'formType': '1',
      'isRead': '1',
      'isRequired': '1',
      'length': '30',
      'name': '身份证号',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '身份证号',
      'value': 'idcard'
    },
    {
      'checks': '',
      'content': '上传身份证正反面后自动显示',
      'description': '',
      'formType': '1',
      'isRead': '1',
      'isRequired': '1',
      'name': '身份证有效期起',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '身份证有效期起',
      'value': 'idStartDate'
    },
    {
      'checks': '',
      'content': '上传身份证正反面后自动显示',
      'description': '',
      'formType': '1',
      'isRead': '1',
      'isRequired': '1',
      'name': '身份证有效期止',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '身份证有效期止',
      'value': 'idEndDate'
    },
    {
      'checks': '',
      'content': '上传身份证正反面后自动显示',
      'description': '',
      'formType': '1',
      'isRead': '1',
      'isRequired': '1',
      'length': '30',
      'name': '民族',
      'optionsVlaue': 'NATION',
      'orderIndex': '',
      'title': '民族',
      'value': 'nation'
    },
    {
      'checks': '',
      'content': '上传身份证正反面后自动显示',
      'description': '',
      'formType': '1',
      'isRead': '1',
      'isRequired': '1',
      'name': '出生日期',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '出生日期',
      'value': 'birthday'
    },
    {
      'checks': '',
      'content': '',
      'description': '请上传您本人手持身份证的照片，并确保照片内您本人和身份证清晰完整',
      'formType': '6',
      'isRead': '0',
      'isRequired': '1',
      requiredIcon: 1,
      'name': '手持身份证',
      'optionsVlaue': '',
      'orderIndex': '',
      'title': '手持身份证',
      'value': 'handIdCard',
    },
  ]
};
